// extracted by mini-css-extract-plugin
export default {"contentBody":"PageContentBody-contentBody-Hetrs","innerContentBody":"PageContentBody-innerContentBody-PtigL"};